module.exports = __webpack_public_path__ + "img/hero.fa29341b.png";